
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Project, User } from '@shared/index';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { ProjectNamePipe } from '../../../../../../shared/pipes/project-name.pipe';
import { AdminService } from '@shared-angular/services/admin.service';
import { ProjectService } from '../../../../../../shared/services/project.service';
import { ToastrService } from '@shared-angular/services/toastr.service';

@Component({
  selector: 'app-transfer-project-modal',
  imports: [FormsModule, ProjectNamePipe, SelectModule, ButtonModule],
  templateUrl: './transfer-project-modal.component.html',
  styleUrl: './transfer-project-modal.component.css'
})
export class TransferProjectModalComponent implements OnInit {
  public project!: Project;
  public users: User<string, string>[] = [];

  constructor(private adminService: AdminService, public projectService: ProjectService, private bsModalRef: BsModalRef, private toastr: ToastrService) { }

  public async ngOnInit(): Promise<void> {
    this.users = await this.adminService.getUsers();
  }

  public async transferProject() {
    await this.projectService.updateProject(this.project);
    this.bsModalRef.hide();
    this.toastr.success('SAVED');
  }
}